/**
 * Every PostHog event name, sent from the browser or any server runtime.
 * `src/lib/analytics/events.ts` re-exports it (with the property types);
 * Convex imports it directly. No imports here: the browser bundles this file.
 *
 * The `projectCreatedFrom*`, `renderTriggered` and `subscription*` names
 * predate this catalogue and keep their original strings.
 */
export const ANALYTICS_EVENTS = {
  mediaUploaded: "media_uploaded",
  youtubeLinkAdded: "youtube_link_added",
  syncMethodSelected: "sync_method_selected",
  editorChangeMade: "editor_change_made",
  generationCompleted: "generation_completed",
  generationFailed: "generation_failed",
  renderCompleted: "render_completed",
  renderFailed: "render_failed",
  signedUp: "signed_up",
  authStarted: "auth_started",
  affiliateSignupAttributed: "affiliate_signup_attributed",
  generationStarted: "generation_started",
  projectCreated: "project_created",
  editorOpened: "editor_opened",
  lyricsCorrected: "lyrics_corrected",
  exportModalOpened: "export_modal_opened",
  exportModalClosed: "export_modal_closed",
  audioDownloaded: "audio_downloaded",
  renderDownloaded: "render_downloaded",
  insufficientCreditsShown: "insufficient_credits_shown",
  featureGateHit: "feature_gate_hit",
  paywallViewed: "paywall_viewed",
  paywallCtaClicked: "paywall_cta_clicked",
  checkoutStarted: "checkout_started",
  uploadRejected: "upload_rejected",
  subscriptionDowngraded: "subscription_downgraded",
  projectCreatedFromCustom: "project_created_from_custom",
  projectCreatedFromSeparateAndAlign: "project_created_from_separate_and_align",
  renderTriggered: "render_triggered",
  subscriptionTrialStarted: "subscription_trial_started",
  subscriptionUpgradedToPremium: "subscription_upgraded_to_premium",
  subscriptionUpgradedFromTrial: "subscription_upgraded_from_trial",
  subscriptionPaidStarted: "subscription_paid_started",
  subscriptionCancellationRequested: "subscription_cancellation_requested",
  subscriptionTrialCancellationRequested:
    "subscription_trial_cancellation_requested",
  subscriptionCancelled: "subscription_cancelled",
  subscriptionResumed: "subscription_resumed",
  creditsSpent: "credits_spent",
  creditsGranted: "credits_granted",
  creditsPurchased: "credits_purchased",
} as const;
